import { useQuery } from '@tanstack/react-query';

import { queries } from '@/queries';

import { useProfile } from './useProfile';

export const useUserCurrentSubscription = () => {
  const { data: profileData } = useProfile();
  return useQuery({
    ...queries.payments.getUserCurrentSubscriptionData,
    enabled: !!profileData,
    select: (data) => ({
      ...data,
      accountType: profileData?.accountType,
    }),
  });
};
